import { createSelector } from 'reselect'
import { uniqBy, groupBy } from 'lodash-es'
import { parseISOToDateTime, toDateId } from '@calendly/datetime'

const calendarsSelector = (state) => state.calendars

const calendarDaysSelector = createSelector(
  calendarsSelector,
  (calendars) => Object.entries(calendars)
    .filter(([key]) => key !== 'options')
    .reduce((memo, [_monthId, calendar]) => memo.concat(calendar.days || []), [])
)

const uniqueCalendarDaysSelector = createSelector(
  calendarDaysSelector,
  (days) => uniqBy(days, (day) => day.date)
)

const availableCalendarDays = createSelector(
  uniqueCalendarDaysSelector,
  (days) => days.filter((day) => day.status === 'available')
)

export const calendarSpotsSelector = createSelector(
  uniqueCalendarDaysSelector,
  (days) => days.reduce((memo, day) => memo.concat(day.spots), [])
)

export const calendarInviteeEventsSelector = createSelector(
  uniqueCalendarDaysSelector,
  (days) => days.reduce((memo, day) => memo.concat(day.invitee_events), [])
)

export const calendarSpotsCountSelector = createSelector(
  calendarSpotsSelector,
  (daySpots) => daySpots.length
)

export const calendarDaysByWeekSelector = createSelector(
  availableCalendarDays,
  (days) => {
    const grouped = groupBy(days, (day) => parseISOToDateTime(day.date).startOf('week', { useLocaleWeeks: true }).toFormat('MM-dd-yyyy'))

    return Object.entries(grouped)
  }
)

export const calendarInviteeEventsByDaySelector = createSelector(
  calendarInviteeEventsSelector,
  (inviteeEvents) => {
    const grouped = groupBy(inviteeEvents, (inviteeEvent) => toDateId(parseISOToDateTime(inviteeEvent.start_time)))

    return Object.entries(grouped)
  }
)

export const uniqueInviteePollVotesSelector = createSelector(
  calendarSpotsSelector,
  (daySpots) => {
    const invitees = daySpots.reduce((memo, spot) => (spot.invitees ? memo.concat(spot.invitees) : memo), [])

    return uniqBy(invitees, (invitee) => invitee && invitee.id)
  }
)
